import {Trans, useTranslation} from 'gatsby-plugin-react-i18next';

const MentalHealthMindfulness = () => {
    const { t } = useTranslation();
    return (
        <>
            <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 mental-health">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12 col-sm-8 col-md-8 col-lg-8">
                        <h1 className="font-weight-semibold hero-heading mt-5 no-br">
                        <Trans>Foster a Mindful <br/>Lifestyle for Your <br/>Team</Trans>
                        </h1>
                        <p className="hero-para font-weight-semibold no-br">
                        <Trans>Elevate mental well-being with our specialized mood <br/>and meditation trackers designed for your workforce.</Trans>
                        </p>
                        <div className="pl-0 col-12 col-md-7 mtb25 d-md-flex justify-content-between align-items-center">
                            <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>


            <section className="position-relative pl-0 pr-0">
                <div className="">
                    <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                        <div className="container custom_container d-flex m-d-block justify-content-center align-items-center home-bg-2 brd22 p-5 mb-5">
                            <div className="col-12 col-md-6">
                                <div className="col-12">
                                    <div className="features-label red-font">
                                    <Trans>Emotion Insights Hub</Trans>
                                    </div>
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Mood Tracker</Trans></h2>
                                    <p className='section-para font-weight-normal greenTick'><ul><li><Trans>Assist employees in charting their emotions, aiding self-awareness and inner calm.</Trans></li><li><Trans>Enable mood selection across a wide spectrum,and also identify factors such as work, family, food,travel and more.</Trans></li></ul></p>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 cta-img p-0'>
                                <div className='d-flex justify-content-end px-0'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1706185098/VantageFit/2023/mental_health-mood_tracker`)} fetchPriority="high" alt="Mood Tracker" width="621" height=""/>
                                </div>
                            </div>
                        </div>
                        <div className="container custom_container d-flex flex-row-reverse m-d-block justify-content-center align-items-center home-bg-2 brd22 p-5">
                            <div className="col-12 col-md-6">
                                <div className="col-12">
                                    <div className="features-label orange-font">
                                    <Trans>Guided Paths to Calm</Trans>
                                    </div>
                                    <h2 className='font-weight-semibold py-2 section-heading no-br'><Trans>Guided Meditation</Trans></h2>
                                    <p className='section-para font-weight-normal greenTick'><ul><li><Trans>Introduce diverse guided meditation sessions for your team, aimed at improving self-awareness, improving sleep quality, and aiding relaxation.</Trans></li><li><Trans>Give employees the choice of meditation sessions of different lengths to fit their needs and schedules.</Trans></li></ul></p>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 cta-img px-0'>
                                <div className='col-12 d-flex justify-content-start px-0'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1706185098/VantageFit/2023/mental_health-guided_meditation`)} loading='lazy' alt="Guided Meditation" width="621" height="760"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="position-relative container">
                <div className="section-heading-top cursive">
                    <h2 className="section-heading font-weight-bold text-center mb-4"><Trans i18nKey="subtextfeat5">Fostering&nbsp;<span className="charmonman green-clr">Balance</span>&nbsp;and&nbsp;<span className="charmonman green-clr">Resilience</span></Trans>&nbsp;!</h2>
                    <div className="section-para text-center no-br"><Trans>Incorporate mindfulness into your team's daily regimen <br/>to promote a well-rounded and resilient lifestyle.</Trans></div>
                </div>
            </section>
            <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12">
                        <h2 className="font-weight-semibold section-heading text-center no-br">
                        <Trans>Cultivate Calm and Serenity</Trans>
                        </h2>
                        <p className="sub-para font-weight-normal text-center mb-5 text-white">
                        <Trans>Join us on a journey to a more mindful, productive day.</Trans>
                        </p>
                        <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                            <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default MentalHealthMindfulness;
